import { Image, Input, Table, TableColumnsType } from "antd";
import { Link } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";
import AddIcon from "components/Icons/AddIcon";
import NextIcon from "components/Icons/NextIcon";
import PreviousIcon from "components/Icons/PreviousIcon";
import { sortIcon } from "components/Table";
import Action from "./components/Action";
import { RouteName } from "constants/route";
import { CityAlertContextProvider } from "./components/CityAlertContext";
import useCity from "hooks/cities/useCity";
import { ICity } from "models/city";

export default function City() {
  const {
    data: { data, loading, page, per_page, search, total },
    handleSearch,
    handlePageChange,
  } = useCity();

  return (
    <CityAlertContextProvider>
      <div className="w-full">
        <div className="w-full px-6 flex flex-wrap-reverse">
          <div className="grow justify-between items-center flex-wrap-reverse gap-5">
            <Link
              to={RouteName.CREATE_CITY}
              className="flex items-center p-3 border rounded-lg border-black w-fit gap-x-2"
            >
              <AddIcon />
              <span className="text-black text-sm font-medium">Add City</span>
            </Link>
          </div>
          <Input
            className="max-w-72 w-full h-auto px-4 py-2 text-base border border-[rgb(0,0,0,0.1)] rounded-3xl"
            prefix={<SearchOutlined className="mr-2" />}
            placeholder="Search..."
            onChange={handleSearch}
            value={search}
          />
        </div>
        <div className="w-full mt-8 px-4">
          <Table
            loading={loading}
            columns={columns}
            dataSource={data}
            onChange={handlePageChange}
            pagination={{
              total,
              pageSize: per_page,
              current: page,
              nextIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                  <NextIcon />
                </span>
              ),
              prevIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                  <PreviousIcon />
                </span>
              ),
            }}
          />
        </div>
      </div>
    </CityAlertContextProvider>
  );
}

const columns: TableColumnsType<ICity> = [
  {
    title: "Name",
    dataIndex: "name",
    sortIcon,
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: "Country",
    dataIndex: "country",
    render: (value: any) => (
      <div className="w-full flex items-center gap-x-2">
        <p>Ethiopian</p>
      </div>
    ),
  },
  {
    title: "Action",
    render: (value: ICity) => <Action city={value} />,
  },
];
